import Swiper, {Autoplay, Pagination} from 'swiper';

class QuotesSlider {
  constructor(element) {
    this.element = element;
    this.swiper = null;
    this.slider = this.element.querySelector('[data-element="slider"]');
    this.sliderAutoplay = this.slider.dataset.autoplay;
    this.navigation = this.element.querySelector('[data-element="navigation"]');
  }

  init() {
    this.swiperInit();
  }

  swiperInit() {
    let autoplayDelay = false;

    if (parseInt(this.sliderAutoplay) > 0) {
      autoplayDelay = {
        delay: parseInt(this.sliderAutoplay) * 1000,
      };
    }

    this.swiper = new Swiper(this.slider, {
      autoplay: autoplayDelay,
      grabCursor: true,
      modules: [Autoplay, Pagination],
      pagination: {
        bulletActiveClass: 'quotes-slider__nav-item-active',
        bulletClass: 'quotes-slider__nav-item',
        clickable: true,
        el: this.navigation,
        renderBullet: function(index, className) {
          const number = index + 1;
          return '<span class="' + className + '">' + number.toString().padStart(2, 0) + '</span>';
        },
      },
    });
  }
}

const quotesSlider = {
  init() {
    const quotesSliderElements = document.querySelectorAll('[data-module="quotes-slider"]');

    if (quotesSliderElements && quotesSliderElements.length) {
      quotesSliderElements.forEach((element) => {
        const quotesSliderElement = new QuotesSlider(element);
        quotesSliderElement.init();
      });
    }
  },
};

export default quotesSlider;
